// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2KKei","list":"PatternAutocomplete_list__nDkTX"};